import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2619 2619">
      <g
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1"
        transform="translate(237 169)"
      >
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1597.5 10l-3 4 3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1646.5 10l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1547.5 80l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1696.5 80l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1542.5 84l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1701.5 84l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1538.5 87l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1705.5 87l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1603.5 120l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1635.5 120l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1594.5 128l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1644.5 128l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1588.5 133l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1650.5 133l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1583.5 137l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1655.5 137l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1667.5 146l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1947.5 198l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1295.5 200l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1955.5 204l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1287.5 206l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1960.5 208l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1282.5 210l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1966.5 213l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1275.5 216l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1257.5 234l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1987.5 234l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1251.5 241l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1247.5 246l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1911.5 262l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1322.5 268l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1918.5 268l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1927.5 277l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1312.5 278l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1934.5 285l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1305.5 286l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1940.5 293l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1299.5 294l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1972.5 388l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1196.5 389l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M2047.5 389l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1175.5 394l20.5.5-20.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1267.5 394l705.5.5-705.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M2048.5 394l20.5.5-20.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1127.5 413l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M2117.5 414l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1120.5 420l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M2123.5 420l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1115.5 426l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1099.5 467l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M2144.5 467l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1172.5 468l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M2144.5 561l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1099.5 562l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M2070.5 562l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1117.5 608l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M2126.5 608l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1127.5 618l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M2116.5 618l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1172.5 637l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M2069.5 637l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1786.5 639l179.5.5-179.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1715.5 640l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1526.5 642l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1785.5 643l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1455.5 652l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1527.5 653l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1456.5 663l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1712.5 672l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1457.5 674l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1529.5 674l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1782.5 675l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1711.5 683l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1530.5 685l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1781.5 686l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1459.5 695l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1531.5 696l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1709.5 704l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1460.5 706l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1779.5 707l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1708.5 715l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1533.5 717l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1778.5 718l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1707.5 726l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1462.5 727l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1534.5 728l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1463.5 738l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1776.5 739l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1705.5 747l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1464.5 749l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1536.5 749l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1775.5 750l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1704.5 758l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1537.5 760l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1466.5 770l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1538.5 771l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1773.5 771l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1702.5 779l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1467.5 781l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1772.5 782l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1701.5 790l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1540.5 792l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1700.5 801l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1541.5 803l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1770.5 803l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1470.5 813l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1542.5 814l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1769.5 814l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1698.5 822l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1471.5 824l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1768.5 825l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1697.5 833l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1544.5 835l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1473.5 845l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1545.5 846l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1766.5 846l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1474.5 856l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1765.5 857l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1694.5 865l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1475.5 867l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1547.5 867l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1693.5 876l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1548.5 878l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1763.5 878l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1477.5 888l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1549.5 889l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1762.5 889l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1691.5 897l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1478.5 899l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1690.5 908l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1551.5 910l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1760.5 910l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1689.5 919l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1480.5 920l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M33.5 921l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M103.5 921l5.5.5-5.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1552.5 921l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1759.5 921l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1481.5 931l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1687.5 940l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1482.5 942l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1757.5 942l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1686.5 951l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1555.5 953l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1756.5 953l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M193.5 954l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M201.5 961l8 9-8-9z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1484.5 963l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1556.5 964l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1755.5 964l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1684.5 972l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1485.5 974l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M214.5 975l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M218.5 980l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1683.5 983l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1486.5 985l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1558.5 985l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1753.5 985l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1682.5 994l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1559.5 996l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1752.5 996l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1488.5 1006l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1560.5 1007l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M152.5 1012l5 6-5-6z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1680.5 1015l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1489.5 1017l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1750.5 1017l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1679.5 1026l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1562.5 1028l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1749.5 1028l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1491.5 1038l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1563.5 1039l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1677.5 1047l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1492.5 1049l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1747.5 1049l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M248.5 1057l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1676.5 1058l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1493.5 1060l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1565.5 1060l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1746.5 1060l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M177.5 1065l.5 499.5h-1l.5-499.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1675.5 1069l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1566.5 1071l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1495.5 1081l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1744.5 1081l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1567.5 1082l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1673.5 1090l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1496.5 1092l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1743.5 1092l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1672.5 1101l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1569.5 1103l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1742.5 1103l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1570.5 1114l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1499.5 1124l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1740.5 1124l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1571.5 1125l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M338.5 1126l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1669.5 1133l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1500.5 1135l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1739.5 1135l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1668.5 1144l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1573.5 1146l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M398.5 1150l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1502.5 1156l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1737.5 1156l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1574.5 1157l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M406.5 1158l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M411.5 1164l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1666.5 1165l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1503.5 1167l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1736.5 1167l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1665.5 1176l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1504.5 1178l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1576.5 1178l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1664.5 1187l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1734.5 1188l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1577.5 1189l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M307.5 1198l25.5.5-25.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1506.5 1199l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1733.5 1199l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1578.5 1200l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1662.5 1208l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1507.5 1210l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M431.5 1213l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M850.5 1217l4.5.5-4.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1915.5 1217l3.5 1.5-2.5.5-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M867.5 1218l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1324.5 1218l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1968.5 1238l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1272.5 1240l-3 4 3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1974.5 1244l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1264.5 1249l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1979.5 1250l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M431.5 1289l414.5.5-414.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1328.5 1289l589.5.5-589.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M859.5 1290l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M870.5 1291l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1062.5 1291l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1320.5 1291l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1247.5 1292l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1067.5 1295l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1317.5 1299l.5 83.5h-1l.5-83.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1073.5 1300l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1081.5 1307l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1102.5 1328l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1110.5 1337l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M841.5 1346l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M853.5 1347l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1020.5 1350l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1026.5 1355l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1034.5 1362l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1045.5 1373l4 5-4-5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1055.5 1384l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1247.5 1385l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1327.5 1389l590.5.5-590.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1063.5 1394l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M996.5 1408l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M842.5 1418l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1006.5 1418l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M352.5 1424l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M349.5 1427l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1014.5 1427l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1262.5 1428l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1978.5 1430l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1266.5 1433l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1274.5 1441l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1966.5 1442l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1279.5 1445l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1962.5 1445l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M937.5 1453l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M943.5 1458l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1920.5 1460l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M950.5 1465l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M957.5 1473l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M393.5 1482l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M338.5 1504l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1188.5 1525l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1058.5 1536l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1189.5 1538l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M985.5 1546l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1117.5 1546l.5 4.5h-1l.5-4.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1059.5 1551l.5 9.5h-1l.5-9.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1817.5 1551l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1741.5 1557l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M248.5 1572l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1449.5 1600l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1454.5 1606l7 8-7-8z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1793.5 1607l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M161.5 1608l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1786.5 1614l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1779.5 1620l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1520.5 1639l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M206.5 1665l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M195.5 1675l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1526.5 1676l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1190.5 1677l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1725.5 1678l.5 6.5h-1l.5-6.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M190.5 1679l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M986.5 1679l.5 6.5h-1l.5-6.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1598.5 1679l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1118.5 1683l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1655.5 1683l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1060.5 1690l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1724.5 1697l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M9.5 1698l4 5-4-5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M987.5 1699l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1723.5 1708l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M89.5 1710l16.5.5-16.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1502.5 1745l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1497.5 1751l-6 7 6-7z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1227.5 1756l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1485.5 1762l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1334.5 1793l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1400.5 1793l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1349.5 1794l4.5.5-4.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1387.5 1794l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1557.5 1794l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1164.5 1798l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1550.5 1802l-8 9 8-9z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1171.5 1805l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1181.5 1814l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1535.5 1816l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1113.5 1832l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1595.5 1838l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1121.5 1841l8 9-8-9z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1578.5 1855l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1143.5 1861l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1570.5 1862l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1326.5 1866l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1407.5 1866l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1565.5 1866l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1339.5 1867l4.5.5-4.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1396.5 1867l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1367.5 1868l9.5.5-9.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1051.5 1872l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1659.5 1872l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1655.5 1877l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1056.5 1878l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1649.5 1884l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1062.5 1885l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1640.5 1894l-10 11 10-11z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1080.5 1903l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1089.5 1911l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1620.5 1913l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1095.5 1916l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1614.5 1918l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1313.5 1923l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1324.5 1924l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1409.5 1924l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1339.5 1925l4.5.5-4.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1396.5 1925l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1309.5 1995l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1321.5 1996l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1410.5 1996l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1337.5 1997l4.5.5-4.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.796"
          strokeOpacity="0.796"
          d="M1394.5 1997l4.5.5-4.5.5v-1z"
        ></path>
        <path d="M1618.5 1h7l9 2q11 4.5 17.5 13.5l12 26 7 11q11.5 16 26.5 28.5 25.5 20.5 58 34l43 17 62 21 52 23q43.3 22.2 74.5 56.5 27.2 30.3 43 72l11 38 4 22v7l2 9v11l1 2.5h27.5l10 2q23 7 37.5 22.5 16 16 21 43v8l1 1v89l-1 1-1 14-6 17q-7.5 15-19.5 25.5-12.6 11.4-31 17l-9 2h-8l-1 1H2042l-19 89.5-2 5-3 18-2 5v4l-2 5-1 9-6 23-1 9-6 23-1 9-6 23-1 9-4 14-1 9-6 23-1 9-6 23-1 9-6 23-1 9-6 23-1 9-6 23-6 32-6 23-1 9-6 23-1 9-6 23-1 9-6 23-1 9-4 14 1.5 1.5 15 1 16 5q15.5 7 26.5 18.5 15.5 16 21 42-1.5 5.5 1 7v95l-1 1-1 11-8 20q-7.4 13.1-18.5 22.5-15 13.5-39 18h-8l-1 1H1818v89.5l-1 1-1 12q-8.1 31.4-28.5 50.5-11.3 10.7-26 18-15 7.7-35.5 9v36.5l-1 1v18l-1 1v10l-1 1-1 15-8 39-10 31q-28.4 72.6-82.5 119.5-50.2 44.3-122 67l-30 8-33 6-15 1-1 1-26 1-1 1h-51l-1-1h-16l-1-1-22-1-1-1h-7l-1-1h-7l-1-1-24-3-39-9-39-13q-70.3-27.2-117.5-77.5-45.9-48.1-67-121l-7-31-2-18-1-1v-8l-1-1v-10l-1-1v-19l-1-1v-132l-1-1-1-14q-9.7-47.2-40.5-73.5-17.4-15.1-40-25l-23-8-36-7h-415l-1.5 1.5-1 10-4 13-7 14q-8.6 14.9-21.5 25.5-18.4 16.6-48 22h-8l-1 1H249v66.5l-5 29q-14.1 46.9-47.5 74.5-26.7 23.8-68 33l-12 1-1 1h-26l-1 1h-57Q15 1707.5 7 1695.5q-4.5-6.5-6-16v-727Q4 937 14.5 929l11-6 11-2h66l1 1h13l17 3 29 10q30.8 14.7 51.5 39.5 22.8 25.7 32 65l2 11v9l1 1v65.5h88.5l1 1 15 1q33 8 52.5 29.5 11.8 12.7 19 30l5 16 1 12 1.5 1.5h417l1 1h16l1 1h10l1 1 15 1 32 6 26 7q29.3 9.2 55 22 55.4 28.1 95.5 71.5 48.8 51.7 73 128l9 37v5l3 13v7l1 1 1 23 1 1v138l1 1 1 15q8.7 40.3 36.5 61.5 27 21.5 67 30l22 4 16 1 1 1h14l1 1h41l1-1h11l1-1 23-3 31-10q24-10.5 40.5-28.5 16.4-17.6 24-44l5-29V1640l-22.5-3-17-6q-22.1-10.4-36.5-28.5-9.1-10.9-15-25l-7-27V1462h-106.5q-1.8-2.7-8-1-29.7-6.3-46.5-25.5-15.2-15.8-20-42v-8l-1-1v-89l1-1v-8l2-9 8-19q7.9-13.1 19.5-22.5 9.9-8.1 23-13l16-4h11.5l-126-581h-26.5l-1-1h-8l-9-2q-23.8-7.7-38.5-24.5-14.2-15.3-19-40v-8l-1-1v-91l1-1 1-13 4-12q7.1-16.9 19.5-28.5 13.6-12.9 34-19l10-2h27.5l1-3.5 1-19 5-29 6-23 11-29q19.6-42.9 52.5-72.5 18.3-16.7 40-30l44-23 45-18 68-24 42-19q32.2-16.3 54.5-42.5 15.6-17.9 24-43L1600.5 8l9-5 9-2zm1.5 104q-36 37-82 64-27 15-56 26l-37 11-61 24q-35 15-61 38-26 22-40 55l-8 22-5 21-2 19-1 1v9h706q-5-74-43-115-30-32-72-50l-56-22-51-16-45-21q-49-27-86-66zm-443 361l-4 2-3 4v89l1 2 5 3h891l2-1 3-4v-88l-1-2-5-5h-889zm97 172l11 55 8 32 1 9 6 23 1 9 8 32 1 9 6 23 1 9 8 32 1 9 8 32 1 9 6 23 1 9 8 32 1 9 8 32 1 9 6 23 1 9 8 32 1 9 6 23 1 9 8 32 1 9 8 32q-1 4 1 4h107l-2-27-1-1v-10l-1-1v-10l-1-1v-10l-1-1v-9l-1-1v-10l-1-1v-10l-2-11v-10l-1-1v-10l-1-1v-10l-2-11-2-32-2-11-1-21-2-11-2-32-2-11-2-32-2-11-1-21-2-11-2-32-2-11-1-21-2-11-2-32-2-11-2-32-2-11-1-21-2-11-2-32-2-11v-4h-180zm252 0l2 28 1 1v10l1 1v10l1 1v10l1 1v9l1 1v10l1 1v10l2 11v10l1 1v10l1 1v10l2 11 2 32 2 11 1 21 2 11 2 32 2 11 1 21 2 11 2 32 2 11 2 32 2 11 1 21 2 11 2 32 2 11 2 32 2 11 1 21 2 11 2 32 2 11 1 3h81l2-26 1-1v-10l1-1v-10l1-1v-10l1-1v-9l1-1v-10l1-1v-10l1-1v-10l2-11 1-21 2-11 2-32 2-11 1-21 2-11 2-32 2-11 1-21 2-11 2-32 2-11 2-32 2-11 1-21 2-11 2-32 2-11 1-21 2-11 2-32 2-11 2-32 2-11v-5h-190zm260 1l-1 5-2 31-1 1-2 31-1 1-2 31-1 1-1 21-2 11-1 21-2 11-2 32-2 11-1 21-2 11-1 21-2 11-1 21-2 11-2 32-2 11v10l-1 1v10l-2 11-1 21-2 11-1 21-2 11-2 32-2 11v10l-1 1v10l-2 11-1 21-2 11-1 21-1 1q-1 6 1 6h109l124-573v-5h-180zM73 992v647h36l11-2q16-5 28-14 13-10 21-25l6-15 2-9v-8l1-1v-499l-1-1-1-12-4-13q-5-13-14-22-13-16-34-23l-13-3H73zm176 206v237h87l13-6q6-5 9-14v-195l-4-9-10-10-11-3h-84zm182 91v57h410l1 1h11l1 1 20 2 22 5 42 15q36 16 63 42 35 34 51 88l4 18 2 21 1 1v21l1 1v131l1 1v10l1 1v7l4 23q15 65 55 107 39 40 97 61l29 9 26 6 31 4 1 1 19 1 1 1h14l1 1h60l1-1h11l1-1h8l1-1 19-2 31-7q62-18 105-56 35-31 56-76 10-22 16-47l5-27 1-20 1-1v-45h-57l-1 51-6 34q-11 41-36 70-27 31-67 49l-41 14-25 5-15 1-1 1h-10l-1 1h-51l-1-1h-14l-1-1-25-2-35-7-31-10-26-12q-24-12-41-30-38-36-50-97l-1-13-1-1v-10l-1-1v-136l-1-1v-12l-1-1-1-16-7-33q-18-64-58-106-28-31-65-52-25-14-54-23l-27-7-23-4-18-1-1-1h-15l-1-1H431zm894 0l-4 2-4 6v86l1 3 6 4h594l4-2 2-3v-90l-6-6h-593zm175 173v83l-1 1 3 10q8 10 24 13h192l12-3 11-7 6-9v-88h-247z"></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1560.5 67l-8 9 8-9z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1683.5 67l8 9-8-9z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1607.5 117l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1632.5 118l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1596.5 127l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1642.5 127l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1280.5 211l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1969.5 215l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1272.5 218l-3 4 3-4z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1260.5 230l-3 4 3-4z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1986.5 232l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1992.5 239l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1324.5 267l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1916.5 267l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1929.5 280l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1124.5 415l-4 5 4-5z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M2120.5 416l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M2068.5 468l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1118.5 610l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M2125.5 610l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1125.5 617l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M2118.5 617l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M9.5 933l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M157.5 1018l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M401.5 1152l4 5-4-5z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M348.5 1205l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1971.5 1240l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1084.5 1309l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1099.5 1324l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1109.5 1335l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1031.5 1360l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1049.5 1378l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M990.5 1402l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1000.5 1411l6 7-6-7z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1268.5 1436l5 6-5-6z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1968.5 1441l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M941.5 1457l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M407.5 1469l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M953.5 1469l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1739.5 1558l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1791.5 1610l-4 5 4-5z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M156.5 1613l-5 6 5-6z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M197.5 1674l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1218.5 1747l5 6-5-6z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1498.5 1749l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1489.5 1758l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1168.5 1803l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1179.5 1813l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1596.5 1836l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1119.5 1838l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1131.5 1850l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1575.5 1857l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1648.5 1886l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1065.5 1889l5 6-5-6z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1074.5 1898l5 6-5-6z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1087.5 1910l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.157"
          strokeOpacity="0.157"
          d="M1623.5 1911l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1599.5 8l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1644.5 8l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1564.5 63l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1679.5 63l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1549.5 78l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1694.5 78l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1620.5 106l7 8-7-8z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1600.5 123l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1638.5 123l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1964.5 211l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1277.5 214l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1975.5 221l6 7-6-7z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1255.5 236l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1989.5 236l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1994.5 242l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1327.5 264l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1319.5 271l-6 7 6-7z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1921.5 271l5 6-5-6z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1197.5 376l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1971.5 381l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1196.5 386l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M2047.5 386l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1267.5 387l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1972.5 391l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1172.5 394l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M2069.5 394l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M2115.5 412l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1169.5 637l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M2072.5 637l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1454.5 644l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1714.5 648l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1527.5 650l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1455.5 655l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1784.5 656l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1713.5 659l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1528.5 661l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1783.5 667l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1782.5 678l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1711.5 680l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1530.5 682l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1458.5 687l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1710.5 691l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1531.5 693l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1459.5 698l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1780.5 699l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1532.5 704l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1779.5 710l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1708.5 712l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1461.5 719l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1707.5 723l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1534.5 725l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1462.5 730l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1777.5 731l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1706.5 734l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1535.5 736l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1463.5 741l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1776.5 742l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1704.5 755l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1465.5 762l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1774.5 763l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1703.5 766l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1538.5 768l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1466.5 773l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1773.5 774l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1539.5 779l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1468.5 794l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1771.5 795l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1700.5 798l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1541.5 800l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1469.5 805l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1770.5 806l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1699.5 809l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1542.5 811l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1470.5 816l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1769.5 817l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1543.5 822l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1697.5 830l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1472.5 837l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1767.5 838l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1696.5 841l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1545.5 843l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1473.5 848l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1766.5 849l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1695.5 852l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1546.5 854l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1474.5 859l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1764.5 870l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1693.5 873l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1548.5 875l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1476.5 880l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1763.5 881l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1692.5 884l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1549.5 886l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1477.5 891l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1550.5 897l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1761.5 902l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1690.5 905l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1479.5 912l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1760.5 913l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1689.5 916l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1552.5 918l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M109.5 921l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1480.5 923l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1688.5 927l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1553.5 929l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1481.5 934l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1758.5 934l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1554.5 940l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1757.5 945l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1686.5 948l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1483.5 955l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1756.5 956l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M198.5 958l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1685.5 959l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1556.5 961l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1484.5 966l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M210.5 970l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1557.5 972l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1754.5 977l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1683.5 980l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1753.5 988l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1682.5 991l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M106.5 992l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1559.5 993l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1487.5 998l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1681.5 1002l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1560.5 1004l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M147.5 1008l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1488.5 1009l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1751.5 1009l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1561.5 1015l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1750.5 1020l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1679.5 1023l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1490.5 1030l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1678.5 1034l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1563.5 1036l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1491.5 1041l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1748.5 1041l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1564.5 1047l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1492.5 1052l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1747.5 1052l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M248.5 1054l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1675.5 1066l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1494.5 1073l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1745.5 1073l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1674.5 1077l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1567.5 1079l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1495.5 1084l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1744.5 1084l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1568.5 1090l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1672.5 1098l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1497.5 1105l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1671.5 1109l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1570.5 1111l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1498.5 1116l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1741.5 1116l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1670.5 1120l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1571.5 1122l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M342.5 1126l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1499.5 1127l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1740.5 1127l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1572.5 1133l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1668.5 1141l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M396.5 1148l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1501.5 1148l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1738.5 1148l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1667.5 1152l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1574.5 1154l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1502.5 1159l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1737.5 1159l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M408.5 1160l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1575.5 1165l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1503.5 1170l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1665.5 1173l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1735.5 1180l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1664.5 1184l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1577.5 1186l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1505.5 1191l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1734.5 1191l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1663.5 1195l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1578.5 1197l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M278.5 1198l28.5.5-28.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1506.5 1202l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1579.5 1208l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1732.5 1212l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1400.5 1215l1 1 106.5.5-106.5.5-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1841.5 1215l-1 2-108.5-.5 108.5-.5 1-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1580.5 1216l80.5.5-80.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M855.5 1217l4.5.5-4.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M870.5 1218l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1320.5 1218l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1919.5 1218l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1966.5 1236l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1274.5 1238l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1268.5 1244l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1247.5 1289l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1325.5 1289l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M856.5 1290l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1071.5 1298l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1078.5 1304l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1105.5 1331l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1116.5 1344l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M845.5 1346l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1038.5 1366l6 7-6-7z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1053.5 1382l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1319.5 1386l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1058.5 1388l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1324.5 1389l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M987.5 1400l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M994.5 1406l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M839.5 1418l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1010.5 1422l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M249.5 1434l84.5.5-84.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1317.5 1461l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M947.5 1462l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1428.5 1462l.5 82.5h-1l.5-82.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M409.5 1466l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M403.5 1473l-6 7 6-7z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1189.5 1534l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1116.5 1535l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1059.5 1546l.5 4.5h-1l.5-4.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M985.5 1549l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1117.5 1551l.5 119.5h-1l.5-119.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1190.5 1559l.5 117.5h-1l.5-117.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1507.5 1560l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1526.5 1568l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1713.5 1568l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1452.5 1604l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1462.5 1614l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1783.5 1617l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M149.5 1620l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M103.5 1638l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1599.5 1642l56.5.5-56.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M216.5 1654l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M210.5 1661l-3 4 3-4z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M203.5 1668l-3 4 3-4z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1526.5 1669l.5 6.5h-1l.5-6.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1655.5 1677l.5 5.5h-1l.5-5.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1598.5 1683l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1525.5 1684l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1725.5 1685l.5 4.5h-1l.5-4.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M986.5 1686l.5 4.5h-1l.5-4.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1060.5 1686l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1118.5 1686l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1654.5 1694l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1061.5 1699l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1724.5 1700l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M987.5 1702l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M106.5 1710l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M35.5 1711l10.5.5-10.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M988.5 1712l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1214.5 1743l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1156.5 1789l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1337.5 1793l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1354.5 1794l8.5.5-8.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1380.5 1794l6.5.5-6.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1161.5 1795l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1553.5 1799l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1175.5 1809l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1541.5 1811l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1533.5 1818l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1599.5 1833l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1115.5 1834l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1592.5 1841l-3 4 3-4z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1581.5 1852l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1136.5 1855l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1336.5 1867l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1399.5 1867l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1355.5 1868l11.5.5-11.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1377.5 1868l9.5.5-9.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1054.5 1876l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1651.5 1882l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1060.5 1883l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1643.5 1891l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1629.5 1905l-3 4 3-4z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1083.5 1906l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1091.5 1913l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1618.5 1915l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1306.5 1922l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1327.5 1924l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1406.5 1924l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1344.5 1925l5.5.5-5.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1390.5 1925l5.5.5-5.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1318.5 1996l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1413.5 1996l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1332.5 1997l4.5.5-4.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1399.5 1997l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.518"
          strokeOpacity="0.518"
          d="M1360.5 1998l18.5.5-18.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1562.5 65l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1681.5 65l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1551.5 76l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1692.5 76l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1618.5 106l-10 11 10-11z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1628.5 114l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1598.5 125l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1640.5 125l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1591.5 131l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1647.5 131l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1971.5 217l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1268.5 222l-7 8 7-8z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1982.5 228l3 4-3-4z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1253.5 238l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1914.5 265l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1931.5 282l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1308.5 283l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1178.5 466l885.5.5-885.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M2071.5 473l.5 85.5h-1l.5-85.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1120.5 612l4 5-4-5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M2122.5 613l-3 4 3-4z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1785.5 648l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1713.5 656l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1784.5 659l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1712.5 667l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1456.5 668l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1529.5 669l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1457.5 679l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1781.5 691l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1709.5 699l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1532.5 701l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1460.5 711l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1533.5 712l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1461.5 722l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1778.5 723l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1706.5 731l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1705.5 742l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1536.5 744l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1464.5 754l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1537.5 755l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1775.5 755l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1702.5 774l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1701.5 785l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1467.5 786l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1540.5 787l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1772.5 787l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1468.5 797l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1771.5 798l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1698.5 817l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1543.5 819l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1471.5 829l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1544.5 830l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1768.5 830l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1695.5 849l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1694.5 860l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1547.5 862l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1765.5 862l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1475.5 872l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1691.5 892l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1762.5 894l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1478.5 904l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1551.5 905l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1479.5 915l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1688.5 924l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1759.5 926l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M12.5 930l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1687.5 935l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1554.5 937l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1758.5 937l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1482.5 947l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1555.5 948l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M.5 955l.5 722.5H0L.5 955z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M196.5 956l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1684.5 967l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1755.5 969l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M212.5 972l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1485.5 979l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1558.5 980l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1486.5 990l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M73.5 992l.5 646 29 .5-28.5.5-1.5-1.5.5-645.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M102.5 992l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1681.5 999l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1752.5 1001l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1680.5 1010l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1561.5 1012l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1489.5 1022l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1562.5 1023l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1490.5 1033l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1749.5 1033l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1677.5 1042l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1676.5 1053l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1565.5 1055l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M249.5 1064l.5 61.5h-1l.5-61.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1493.5 1065l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1746.5 1065l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1566.5 1066l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1745.5 1076l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1673.5 1085l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1496.5 1097l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1743.5 1097l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1569.5 1098l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1497.5 1108l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1742.5 1108l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1670.5 1117l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1669.5 1128l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1572.5 1130l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1500.5 1140l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1739.5 1140l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1573.5 1141l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1666.5 1160l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1736.5 1172l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1576.5 1173l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1504.5 1183l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1663.5 1192l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M249 1198l29 .5-28 .5-.5 235-.5-236z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1662.5 1203l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1733.5 1204l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M432.5 1216l407.5.5-407.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M860.5 1217l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1276.5 1236l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M431.5 1290l.5 19.5h-1l.5-19.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M852.5 1290l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M865.5 1291l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1996.5 1296l.5 87.5h-1l.5-87.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1076.5 1302l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1088.5 1313l10 11-10-11z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1107.5 1333l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1113.5 1340l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M848.5 1346l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1029.5 1358l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1051.5 1380l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M992.5 1404l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M835.5 1418l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1012.5 1424l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1976.5 1433l-7 8 7-8z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1818.5 1461l.5 86.5h-1l.5-86.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M405.5 1471l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M396.5 1480l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M249.5 1505l.5 62.5h-1l.5-62.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1189.5 1531l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1116.5 1538l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1059.5 1542l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1428.5 1545l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1190.5 1548l.5 10.5h-1l.5-10.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M985.5 1552l.5 5.5h-1l.5-5.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1504.5 1557l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1529.5 1568l183.5.5-183.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1796.5 1604l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M158.5 1611l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1464.5 1616l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1526.5 1640l.5 28.5h-1l.5-28.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1599.5 1643l.5 26.5h-1l.5-26.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1655.5 1643l.5 33.5h-1l.5-33.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M212.5 1659l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1117.5 1671l.5 6.5h-1l.5-6.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M199.5 1672l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1060.5 1680l.5 5.5h-1l.5-5.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1598.5 1687l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1118.5 1689l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1725.5 1690l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M986.5 1691l.5 3.5h-1l.5-3.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1654.5 1691l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1724.5 1703l.5 2.5h-1l.5-2.5z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M110.5 1710l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M46.5 1711l20.5.5-20.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1216.5 1745l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1224.5 1753l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1341.5 1793l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1395.5 1793l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1363.5 1794l16.5.5-16.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1555.5 1797l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1538.5 1814l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1111.5 1829l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1117.5 1836l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1588.5 1845l-6 7 6-7z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1134.5 1853l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1573.5 1859l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1333.5 1867l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1402.5 1867l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1349.5 1868l5.5.5-5.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1387.5 1868l4.5.5-4.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1653.5 1880l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1058.5 1881l1 2-1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1646.5 1888l-2 3 2-3z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1071.5 1895l2 3-2-3z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1625.5 1909l-1 2 1-2z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1318.5 1923l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1331.5 1924l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1403.5 1924l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1350.5 1925l8.5.5-8.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1383.5 1925l6.5.5-6.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1315.5 1996l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1328.5 1997l3.5.5-3.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1403.5 1997l2.5.5-2.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1350.5 1998l9.5.5-9.5.5v-1z"
        ></path>
        <path
          fillOpacity="0.255"
          strokeOpacity="0.255"
          d="M1379.5 1998l8.5.5-8.5.5v-1z"
        ></path>
      </g>
    </svg>
  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'WallLights')

export default icon
